import React, { FC } from 'react'
import pluralize from 'pluralize'
import { DialogNames } from 'src/enums'
import { BulkConfirmationModal } from './bulkConfirmationModal'

interface SelectedSensor {
  uniqueId: string
  imei: string | number | null
}

interface BulkAssignSensorsConfirmationModalProps {
  selectedSensors: SelectedSensor[]
  contractorName: string
  onConfirm: () => void
  onClose: () => void
  isLoading?: boolean
}

export const BulkAssignSensorsConfirmationModal: FC<BulkAssignSensorsConfirmationModalProps> = ({
  selectedSensors,
  contractorName,
  onConfirm,
  onClose,
  isLoading = false,
}) => {
  const count = selectedSensors.length

  return (
    <BulkConfirmationModal
      name={DialogNames.AssignSensorsBulkConfirmation}
      title="Assign sensors to contractor"
      confirmationText={`Are you sure to assign ${pluralize('sensor', count, true)} to ${contractorName}?`}
      selectedSensors={selectedSensors}
      confirmLabel="Assign"
      onConfirm={onConfirm}
      onClose={onClose}
      isLoading={isLoading}
    />
  )
}
